import { Button } from '@givebutter/primitives/button';
import { productColors } from '@givebutter/util';
import { CopyProps } from 'components/snippet/copy/types';
import styled from 'styled-components';

const CopyButton = styled(Button)<CopyProps>`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    font-family: ${props => props.theme.typography.font};
    & > svg {
        color: ${props =>
            props.didCopy ? productColors.success[400] : productColors.gray[300]} !important;
        margin-left: -2px;
        margin-right: 1px;
    }
    & > svg:hover {
        color: lightgrey;
    }
`;

export { CopyButton };
